import { Component, Input } from '@angular/core';
import { WhiteboardDrawing, WhiteboardDrawingsService, WhiteboardEventsService } from '@lemberger/whiteboards';
import { PageService } from '../../../../../services/page.service';
import { BookviewerWhiteboardDrawingsService } from '../../../../../services/bookviewer-whiteboard-drawings.service';
import {
    WhiteboardDrawingsListItemContextMenuComponent
} from './whiteboard-drawings-list-item-context-menu/whiteboard-drawings-list-item-context-menu.component';
import { NgClass, NgStyle } from '@angular/common';

@Component({
    selector: 'app-whiteboard-drawings-list-item',
    templateUrl: './whiteboard-drawings-list-item.component.html',
    styleUrls: ['./whiteboard-drawings-list-item.component.scss'],
    standalone: true,
    imports: [
        WhiteboardDrawingsListItemContextMenuComponent,
        NgStyle,
        NgClass
    ]
})
export class WhiteboardDrawingsListItemComponent {
    static idPrefix = 'whiteboardListItem';
    @Input() whiteboard: WhiteboardDrawing;

    constructor(
        private whiteboardService: WhiteboardDrawingsService,
        private whiteboardEventService: WhiteboardEventsService,
        private whiteboardDrawingService: BookviewerWhiteboardDrawingsService,
        private whiteboardEventsService: WhiteboardEventsService,
        public pageService: PageService) {
    }

    delete(): void {
        this.whiteboardService.deleteWhiteboard(this.whiteboard.book_id, this.whiteboard).subscribe(
            () => {
                this.whiteboardService.whiteboardEvents.next({
                    whiteboardDrawing: this.whiteboard,
                    eventType: 'deleted'
                });
            }
        );
    }

    openWhiteboard(): void {
        this.whiteboardEventService.emitOpenWhiteboard(this.whiteboard);
    }

    openWhiteboardVideo(): void {
        this.whiteboardEventService.emitOpenWhiteboardVideo(this.whiteboard);
    }

    addToPage(): void {
        this.whiteboardEventsService.emitLinkWhiteboardToPage(this.whiteboard);
    }

    setColor(color): void {
        this.whiteboard.color = color;
        this.whiteboardDrawingService.updateWhiteboard(this.whiteboard.book_id, this.whiteboard).subscribe();
    }

    setIcon(icon): void {
        this.whiteboard.icon = icon;
        this.whiteboardDrawingService.updateWhiteboard(this.whiteboard.book_id, this.whiteboard).subscribe();
    }
}
